/* nerva-scripts.js — shared interactions for LUMORA clone sections */
(function(){
  if(window.__nervaInit){return;} window.__nervaInit=1;
  var d=document;
  d.documentElement.classList.add('nerva-js');

  function easeOutCubic(p){ return 1-Math.pow(1-p,3); }

  /* Horizon uses .page-wrapper (overflow:auto) as the scroll container on desktop and the
     window on mobile. Native smooth scroll is blocked on the container, so we animate instant
     scrollTop assignments frame-by-frame, with a guaranteed final set as a fallback. */
  function nervaScrollTo(t){
    var pw=d.querySelector('.page-wrapper');
    var useC=false, sc=null;
    if(pw){ var s=getComputedStyle(pw); if((s.overflowY==='auto'||s.overflowY==='scroll') && pw.scrollHeight>pw.clientHeight+20){ useC=true; sc=pw; } }
    var rect=t.getBoundingClientRect();
    var start = useC ? sc.scrollTop : (window.pageYOffset||d.documentElement.scrollTop||0);
    var target = useC ? (sc.scrollTop + rect.top - sc.getBoundingClientRect().top - 80) : (start + rect.top - 80);
    if(target<0){target=0;}
    function setTop(v){ if(useC){ sc.scrollTop=v; } else { window.scrollTo(0,v); } }
    if(useC){ sc.style.scrollBehavior='auto'; }
    var t0=null, dur=480;
    function step(now){
      if(t0===null){t0=now;}
      var p=Math.min((now-t0)/dur,1);
      setTop(start+(target-start)*easeOutCubic(p));
      if(p<1){ requestAnimationFrame(step); }
    }
    requestAnimationFrame(step);
    // Fallbacks in case rAF is throttled (background tab etc.) — guarantee we land.
    setTimeout(function(){ setTop(target); }, 120);
    setTimeout(function(){ setTop(target); }, 560);
  }

  function fmtVal(n,fmt){
    if(fmt==='k'){ return Math.round(n/1000)+'K+'; }
    if(fmt==='m'){ var m=n/1000000; return (m>=10?Math.round(m):m.toFixed(1))+'M+'; }
    if(fmt==='pct'){ return Math.round(n)+'%'; }
    if(fmt==='dec'){ return n.toFixed(1); }
    return Math.round(n).toLocaleString();
  }
  function runCount(el){
    var target=parseFloat(el.getAttribute('data-count')); if(isNaN(target)){return;}
    var fmt=el.getAttribute('data-fmt')||'';
    var dur=1400, t0=null;
    function step(ts){ if(!t0){t0=ts;} var p=Math.min((ts-t0)/dur,1); el.textContent=fmtVal(target*easeOutCubic(p),fmt); if(p<1){requestAnimationFrame(step);} }
    requestAnimationFrame(step);
  }

  function ready(fn){ if(d.readyState!=='loading'){fn();} else { d.addEventListener('DOMContentLoaded',fn); } }
  ready(function(){
    var revs=[].slice.call(d.querySelectorAll('[data-reveal]'));
    if('IntersectionObserver' in window && revs.length){
      var io=new IntersectionObserver(function(es){ es.forEach(function(e){ if(e.isIntersecting){ e.target.classList.add('nerva-in'); io.unobserve(e.target); } }); },{rootMargin:'0px 0px -6% 0px',threshold:0.08});
      revs.forEach(function(el){ io.observe(el); });
    } else { revs.forEach(function(el){ el.classList.add('nerva-in'); }); }

    var counters=[].slice.call(d.querySelectorAll('[data-count]'));
    if(counters.length){
      if('IntersectionObserver' in window){
        var cio=new IntersectionObserver(function(es){ es.forEach(function(e){ if(e.isIntersecting){ runCount(e.target); cio.unobserve(e.target); } }); },{threshold:0.4});
        counters.forEach(function(el){ cio.observe(el); });
      } else { counters.forEach(runCount); }
    }
  });

  d.addEventListener('click',function(e){
    var a=e.target.closest?e.target.closest('[data-nerva-scroll]'):null; if(!a){return;}
    var href=a.getAttribute('href')||'';
    var hi=href.indexOf('#'); if(hi<0){return;}
    var id=href.slice(hi+1); if(!id){return;}
    var t=d.getElementById(id); if(!t){return;}
    e.preventDefault();
    nervaScrollTo(t);
  });

  d.addEventListener('click',function(e){
    var b=e.target.closest?e.target.closest('[data-ripple]'):null; if(!b){return;}
    var r=b.getBoundingClientRect(); var s=Math.max(r.width,r.height);
    var sp=d.createElement('span'); sp.className='nerva-ripple';
    sp.style.width=sp.style.height=s+'px';
    sp.style.left=(e.clientX-r.left-s/2)+'px'; sp.style.top=(e.clientY-r.top-s/2)+'px';
    if(getComputedStyle(b).position==='static'){ b.style.position='relative'; }
    if(getComputedStyle(b).overflow==='visible'){ b.style.overflow='hidden'; }
    b.appendChild(sp); setTimeout(function(){ if(sp.parentNode){sp.parentNode.removeChild(sp);} },650);
  });

  d.addEventListener('pointermove',function(e){
    var m=e.target.closest?e.target.closest('[data-magnetic]'):null;
    if(m){ var rm=m.getBoundingClientRect(); var mx=e.clientX-(rm.left+rm.width/2); var my=e.clientY-(rm.top+rm.height/2); m.style.transform='translate('+(mx*0.18).toFixed(1)+'px,'+(my*0.3).toFixed(1)+'px)'; }
    var t=e.target.closest?e.target.closest('[data-tilt]'):null;
    if(t){ var rt=t.getBoundingClientRect(); var px=(e.clientX-rt.left)/rt.width-0.5; var py=(e.clientY-rt.top)/rt.height-0.5; t.style.transform='perspective(900px) rotateX('+(-py*5).toFixed(2)+'deg) rotateY('+(px*5).toFixed(2)+'deg)'; }
  });
  d.addEventListener('pointerleave',function(e){
    var m=e.target.closest?e.target.closest('[data-magnetic]'):null; if(m){ m.style.transform=''; }
    var t=e.target.closest?e.target.closest('[data-tilt]'):null; if(t){ t.style.transform=''; }
  },true);

  d.addEventListener('click',function(e){
    var b=e.target.closest?e.target.closest('[data-nerva-cta]'):null; if(!b){return;}
    e.preventDefault(); var id=b.getAttribute('data-product-id'); if(!id){return;}
    b.style.opacity='.7';
    fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({items:[{id:parseInt(id,10),quantity:1}]})}).then(function(r){ if(!r.ok){throw 0;} window.location.href='/cart'; }).catch(function(){ window.location.href='/cart'; });
  });
})();
